import { motion } from "framer-motion";
import { Phone, Mail, MapPin } from "lucide-react";
import { WhatsAppIcon } from "@/components/WhatsAppBadge";

export default function ContactSection() {
  return (
    <section id="contatti" data-testid="contact-section" className="py-24 md:py-32 bg-[#f0ebe1] border-t border-[#0b2545]/10 relative overflow-hidden">
      <div className="absolute inset-0 df-pattern" />
      <div className="relative max-w-4xl mx-auto px-6 space-y-12">
        <div className="text-center space-y-4">
          <div className="df-ornament justify-center text-xs uppercase font-mono-df tracking-widest">
            <span>Parla con Noi</span>
          </div>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl text-[#0b2545] font-normal">Contattaci Direttamente</h2>
          <p className="text-sm text-[#0b2545]/80 max-w-lg mx-auto">
            Chiamaci o scrivici su WhatsApp: il team Dahmani Food risponde in giornata con listino e disponibilità per la tua attività.
          </p>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.2, 0.7, 0, 1] }}
          className="grid grid-cols-1 md:grid-cols-3 gap-6"
        >
          <a data-testid="contact-card-whatsapp" href="https://wa.me/393756088043?text=Salve%20Dahmani%20Food%2C%20vorrei%20informazioni%20sui%20vostri%20prodotti%20all%27ingrosso." target="_blank" rel="noopener noreferrer"
            className="p-8 rounded-3xl bg-[#25D366] text-white space-y-4 hover:bg-[#1ebe5b] hover:-translate-y-1 transition-all duration-300 shadow-lg shadow-[#25D366]/25 group">
            <span className="w-12 h-12 rounded-2xl bg-white/20 flex items-center justify-center">
              <WhatsAppIcon className="w-6 h-6" />
            </span>
            <span className="block font-bold uppercase tracking-wider text-white/80 text-xs">WhatsApp</span>
            <span className="block font-display text-2xl">Risposta rapida</span>
            <span className="block text-xs text-white/80">Il canale più veloce per listino e ordini</span>
          </a>
          <a data-testid="contact-card-telefono" href="tel:+393756088043"
            className="p-8 rounded-3xl bg-[#0b2545] text-white border border-[#d4af37]/40 space-y-4 hover:bg-[#06152d] hover:-translate-y-1 transition-all duration-300 shadow-lg shadow-[#0b2545]/20 group">
            <span className="w-12 h-12 rounded-2xl bg-[#d4af37]/20 text-[#d4af37] flex items-center justify-center">
              <Phone className="w-6 h-6" />
            </span>
            <span className="block font-bold uppercase tracking-wider text-[#d4af37] text-xs">Chiamaci</span>
            <span className="block font-display text-2xl group-hover:text-[#d4af37] transition-colors">+39 375 608 8043</span>
            <span className="block text-xs text-white/70">Lun-Sab, orario lavorativo</span>
          </a>
          <a data-testid="contact-card-email" href="mailto:hamid_dahmani@icloud.com"
            className="p-8 rounded-3xl bg-white border border-[#0b2545]/10 space-y-4 hover:border-[#d4af37] hover:-translate-y-1 transition-all duration-300 shadow-lg shadow-[#0b2545]/5 group">
            <span className="w-12 h-12 rounded-2xl bg-[#0b2545]/10 text-[#0b2545] flex items-center justify-center">
              <Mail className="w-6 h-6" />
            </span>
            <span className="block font-bold uppercase tracking-wider text-[#0b2545] text-xs">Email Diretta</span>
            <span className="block font-display text-lg text-[#0b2545] group-hover:text-[#c59b27] transition-colors break-all">hamid_dahmani@icloud.com</span>
            <span className="block text-xs text-[#0b2545]/60">Per richieste scritte e documenti</span>
          </a>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
          data-testid="contact-address"
          className="flex items-center justify-center gap-3 text-sm text-[#0b2545]/70"
        >
          <MapPin className="w-4 h-4 text-[#c59b27]" />
          <span>Sede: <span className="font-semibold text-[#0b2545]">Via Alessandro Volta, 15 — 20089 Rozzano (MI)</span></span>
        </motion.div>
      </div>
    </section>
  );
}
